import { render, staticRenderFns } from "./ChainEditor.vue?vue&type=template&id=77946390&scoped=true"
import script from "./ChainEditor.vue?vue&type=script&lang=js"
export * from "./ChainEditor.vue?vue&type=script&lang=js"
import style0 from "./ChainEditor.vue?vue&type=style&index=0&id=77946390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77946390",
  null
  
)

export default component.exports